import {I18n} from '@aws-amplify/core';
import { modals } from '@mantine/modals';
import { Text } from '@mantine/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {AiOutlineBank} from 'react-icons/ai'
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {useInvoiceItemsSelection} from "../hooks/useInvoiceItemsSelection.ts";
import {useInvoiceItems} from "../hooks/useInvoiceItems.ts";


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions();
    const { selectedRecords, clearSelection } = useInvoiceItemsSelection();
    const { deleteRecords } = useInvoiceItems();

    const handleDelete = () => {
        const count = selectedRecords.length;
        const itemText = count === 1 ? 'item' : 'items';
        
        modals.openConfirmModal({
            title: 'Delete Invoice Items',
            children: (
                <Text size="sm">
                    Are you sure you want to delete {count} {itemText}? This action cannot be undone.
                </Text>
            ),
            labels: { confirm: 'Delete', cancel: 'Cancel' },
            confirmProps: { color: 'red' },
            onConfirm: () => {
                const ids = selectedRecords.map(record => record.id);
                deleteRecords(ids);
                clearSelection();
            },
        });
    };

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteInvoiceItem)) {
        tools.push(
            <DeleteRecordButton 
                key='delete' 
                count={selectedRecords.length}
                onClick={handleDelete}
            />
        );
    }

    if (allowedActions.includes(rbacActions.CreateInvoiceItem)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Invoice Items')}
            icon={<AiOutlineBank/>}
            tools={useTools()}
        />
    );
};

